<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-barcode text-primary mr-2"></i>Gestión de CNAE
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Códigos CNAE
                    <export-actions :rows="getCnaesFilteredData(this.exportRows)" :onClickExportButton="onExportButton">
                    </export-actions>
                </b-row>


                <b-row>
                    <b-col>
                        <v-server-table ref="cnaesTable" :columns="columns" :options="options" :theme="theme"
                            class="dataTable" md="12" lg="12" sm="12">
                            <template slot="uuid" slot-scope="props">
                                <i size="sm" @click.stop="selectCnae(props.row.uuid)" v-b-modal.newCnae
                                    class="fa fa-pencil text-primary">
                                </i>
                            </template>

                            <template slot="active" slot-scope="props">
                                <span v-if="!!props.row.active">Si</span>
                                <span v-else>No</span>
                            </template>
                        </v-server-table>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="text-right">
                        <b-form-checkbox type="checkbox" v-bind:value="false" v-bind:unchecked-value="true" stacked v-model="search.active" name="hide">Mostrar
                            inactivos
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-card>
        </b-row>

        <b-modal id="newCnae" ref="newCnae" title="Definir CNAE" ok-title="Guardar" cancel-title="Cancelar" hide-footer
            v-model="show" @ok="store">

            <b-form @submit.prevent="store">

                <b-form-group class="w-100 flex-wrap" id="codeGroup" label="<strong>Código *</strong>" label-for="code">
                    <b-form-input v-validate="'required|min:3'" type="text" id="code" name="code"
                        placeholder="Código CNAE" :state="validateState('cnae.code')" v-model="cnae.code"
                        aria-describedby="checkCode"></b-form-input>
                    <div class="text-danger mb-4" id="checkCode">
                        <small>{{ errors.first('code') }}</small>
                    </div>
                </b-form-group>

                <label for="activity"><strong>Actividad *</strong></label>
                <b-form-textarea id="activity" name="activity" v-model="cnae.activity"
                    placeholder="Describa la actividad" v-validate="'required|min:3'"
                    :state="validateState('cnae.activity')" aria-describedby="checkActivity" :rows="3" :max-rows="6"
                    :required="true">
                </b-form-textarea>
                <div class="text-danger mb-4" id="checkActivity">
                    <small>{{ errors.first('activity') }}</small>
                </div>

                <div v-if="cnae.uuid" class="d-inline-block float-right w-100">
                    <div class="text-right"><strong>Activo</strong></div>
                    <div class="text-right">
                        <label class="switch switch-3d switch-success">
                            <input type="checkbox" class="switch-input" v-model="cnae.active" checked>
                            <span class="switch-slider"></span>
                        </label>
                    </div>
                </div>

                <b-row class="border-top pt-3 px-3">
                    <button v-if="cnae.uuid && mixinCheckPermission('CNAE_DELETE')" type="button"
                        class="btn btn-brand btn-danger col-auto mr-auto btn-lg" sm="12" @click="remove()">Eliminar
                    </button>
                    <button v-else type="button" @click="hideModal()"
                        class="btn btn-brand btn-secondary col-auto mr-auto btn-lg" sm="12">Cerrar
                    </button>
                    <b-button v-if="mixinCheckPermissions(['CNAE_NEW', 'CNAE_EDIT'])" type="submit" variant="primary"
                        class="col-auto btn-lg float-right" sm="12" :disabled="errors.any() || !validate()">Guardar
                    </b-button>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import VueNotifications from 'vue-notifications';
import Vue from 'vue';
import { ServerTable, Event } from 'vue-tables-2';
import form from '@/helpers/form';
import { request } from '@/helpers/services';
import ExportActions from '@/components/ExportActions';
import { deleteCnae } from '@/api/cnae-api';

import { getPaginatedCnaes } from '@/api/cnae-api';

Vue.use(ServerTable);

export default {
    name: 'listCNAE',
    components: {
        ServerTable,
        Event,
        ExportActions
    },
    async mounted() {
        this.$eventHub.$on('newCnae', obj => {
            this.flush();
            this.$refs.newCnae.show();
        });
        this.$eventHub.$emit('captureMenu', this.topMenu);
        this.options.texts = form.tableLabels();

        Event.$on('vue-tables.loading', (data) => {
            this.$_loadingMixin_showLoading();
            this.count = 0;
            this.loading = true;
            //this.$refs.cnaesTable.data = [];
            if (!!document.querySelector('.VueTables__no-results')) {
                document.querySelector('.VueTables__no-results').style.display = 'none';
            }
            if (!!document.querySelector('.VueTables__row')) {
                document.querySelector('.VueTables__row').style.display = 'none';
            }
        });
        Event.$on('vue-tables.loaded', (data) => {
            if (!!data && !!data.count) {
                this.count = data.count;
            }
            this.$_loadingMixin_hideLoading();
            this.loading = false;
            if (!!document.querySelector('.VueTables__no-results')) {
                document.querySelector('.VueTables__no-results').style.display = 'table-row';
            }
            if (!!document.querySelector('.VueTables__row')) {
                document.querySelector('.VueTables__row').style.display = 'table-row';
            }
        });


        //this.$store.dispatch('loadCnaes');

    },
    beforeDestroy() {
        this.$eventHub.$off('newCnae');
    },
    data: function () {
        return {
            topMenu: [
                {
                    name: 'Inicio',
                    path: '/admin/dashboard',
                    brand: 'fa fa-home'
                },
                {
                    name: 'Nuevo CNAE',
                    emit: 'newCnae',
                    brand: 'fa fa-barcode',
                    permissions: ['CNAE_NEW']
                },
            ],
            cnae: {
                code: "",
                activity: "",
                uuid: 0,
                active: false,
            },
            show: false,
            exportRows: [],
            columns: [
                'uuid',
                'code',
                'activity',
                'previousActivity',
                'active'
            ],
            options: {
                headings: {
                    uuid: {
                        text: '',
                        id: 'fit'
                    },
                    code: 'Código',
                    activity: 'Actividad',
                    previousActivity: 'Actividad previa',
                    active: 'Activo'
                },
                columnsClasses: { uuid: "fit" },
                sortable: [
                    'code',
                    'activity',
                    'previousActivity'
                ],
                filterable: [
                    'code',
                    'activity',
                    'previousActivity'
                ],
                sortIcon: {
                    base: 'fa',
                    up: 'fa-sort-asc',
                    down: 'fa-sort-desc',
                    is: 'fa-sort'
                },
                perPageValues: [10, 25, 50, 100, 500, 1000],
                texts: null,
                pagination: {
                    chunk: 5,
                    edge: true,
                    nav: 'scroll'
                },
                requestFunction: async (data) => {
                    this.search.query = data.query;
                    this.search.page = data.page;
                    this.search.itemsPerPage = data.limit;
                    let result = await getPaginatedCnaes(this.searchData);
                    this.exportRows = result.cnaes;
                    return result;
                },
                responseAdapter: (data) => {
                    return {
                        data: data.cnaes,
                        count: data.count
                    }
                },
            },
            search: {
                page: 1,
                itemsPerPage: 10,
                status: null,
                category: null,
                clientPhone: null,
                headquarters: null,
                adviser: null,
                memberCode: null,
                number: null,
                dates: null,
                all: false,
                query: null,
                active: true
            },
            useVuex: false,
            theme: 'bootstrap4',
            template: 'default',
            filter: {
                showInactive: false
            }
        }
    },
    watch: {
        'search.active': function () {
            this.$refs.cnaesTable.refresh();
        }
    },
    computed: {
        ...mapGetters([
            'activeCnaes'
        ]),
        ...mapState([
            'cnaes'
        ]),
        tableData() {
            if (!!this.filter.showInactive) {
                return this.cnaes.list;
            } else {
                return this.activeCnaes;
            }
        },
        searchData() {
            let data = {
                page: this.search.page,
                itemsPerPage: this.search.itemsPerPage,
                paginated: true,
                active: this.search.active
            };

            if (!!this.search.query && this.search.query !== null && this.search.query !== '') {
                data['searchField'] = this.search.query;
            }

            return data;
        }

    },
    methods: {

        async onExportButton() {
            let exportFilters = this.searchData;
            delete exportFilters.page;
            delete exportFilters.itemsPerPage;
            exportFilters.paginated = false;
            let result = await getPaginatedCnaes(exportFilters);
            return this.getCnaesFilteredData(result.cnaes);
        },

        async store(evt) {
            try {
                this.$_loadingMixin_showLoading();
                if (this.cnae.uuid) {
                    const resp = await request('cnae/' + this.cnae.uuid, 'post', 200, this.cnae);
                } else {
                    const resp = await request('cnae', 'post', 201, this.cnae);
                }
                this.show = false;
                this.flush();
                this.$store.dispatch('loadCnaes');
            } catch (error) {
                this.$_loadingMixin_hideLoading();
                this.showErrorMsg();
            } finally {
                this.$_loadingMixin_hideLoading();
            }
        },
        remove() {
            swal({
                title: '¿Desea eliminar la actividad CNAE?',
                text: "Esta operación no se podrá revertir",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Confirmar',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                reverseButtons: true
            }).then((response) => {
                if (!!response.value) {
                    this.$_loadingMixin_showLoading();
                    deleteCnae(this.cnae.uuid)
                        .then(() => {
                            this.flush();
                            this.$store.dispatch('loadCnaes');
                            this.$_notificationMixin_success('Operación completada', 'La actividad CNAE ha sido eliminado');
                            this.$_loadingMixin_hideLoading();
                            this.show = false
                        })
                        .catch(() => {
                            this.$_notificationMixin_error('Error en la operación', 'No se ha podido eliminar la actividad CNAE');
                            this.$_loadingMixin_hideLoading();
                        });
                }
            });
        },
        selectCnae(uuid) {
            this.flush();
            console.log(this.tableData)
            let dp = this.tableData.find(dep => (dep.uuid === uuid));
            this.cnae = Object.assign({}, this.cnae, dp);
        },
        flush() {
            this.cnae.uuid = 0;
            this.cnae.code = "";
            this.cnae.activity = "";
            this.cnae.previousActivity = "";
            this.cnae.active = false;
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.errors.has(ref);
            }
            return null;
        },
        validate() {
            if (!this.cnae.code || !this.cnae.activity) {
                return false;
            } else {
                return true;
            }
        },
        hideModal() {
            this.$refs.newCnae.hide();
        },
        getCnaesFilteredData(rows) {

            return rows ? rows.map(cnae => ({
                'Código': cnae.code,
                'Actividad': cnae.activity,
                'Actividad Previa': cnae.previousActivity
            })) : [];
        }
    },
    notifications: {
        showSuccessMsg: {
            type: VueNotifications.types.success,
            title: 'Operación Completada',
            message: 'Código guardado con éxito'
        },
        showErrorMsg: {
            type: VueNotifications.types.error,
            title: 'Acceso denegado',
            message: 'Algo salió mal'
        },
        showGetErrorMsg: {
            type: VueNotifications.types.error,
            title: 'Error inesperado',
            message: 'Problema al recuperar el listado'
        }
    },
}
</script>
